import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { ElxFilter, ElxTable, FilterOptionPillMode, } from "@elixir/components";
import { Label, SelectionMode, Spinner, SpinnerSize, Stack, } from "@fluentui/react";
import { SearchType, } from "../../models";
import "./CustomerSearch.css";
import { useCustomerDataDispatch, useCustomerDataState, } from "../../reducers/CustomerSearchContext/CustomerSearchContextProvider";
import { GetCountryDetailAsDropdownOption } from "../../library/utilities/GetDropdownOption";
import SearchTags from "../SearchWithTagsAndOptions/SearchTags";
import { useCommercialContextState } from "../../reducers/CommercialContext/CommercialContextProvider";
const PartnerSearch = ({ children, partnerSearchData, partnerDataResultDispatch, cancelDispatch, }) => {
    var _a, _b, _c;
    const [selections, setSelections] = useState([]);
    const [displayPartnerResults, setDisplayPartnerResults] = useState([]);
    const partnerDataSate = useCustomerDataState();
    const partnerDataDispatch = useCustomerDataDispatch();
    const [partnerResults, setPartnerResults] = React.useState((_a = partnerDataSate.PartnerData) !== null && _a !== void 0 ? _a : []);
    const commercialContextState = useCommercialContextState();
    const midStack = { childrenGap: 5 };
    const [selectedTags, setSelectedTags] = useState([]);
    const columns = [
        {
            key: "column0",
            name: "Partner ID #",
            fieldName: "partnerId",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column1",
            name: "Partner Name",
            fieldName: "partnerName",
            minWidth: 160,
            maxWidth: 160,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column2",
            name: "Parent ID Number #",
            fieldName: "parentIdNumber",
            minWidth: 160,
            maxWidth: 160,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column3",
            name: "Parent Name",
            fieldName: "parentName",
            minWidth: 180,
            maxWidth: 180,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column4",
            name: "Subsidiary Name",
            fieldName: "subsidiaryName",
            minWidth: 160,
            maxWidth: 160,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column5",
            name: "Segment Name",
            fieldName: "segmentName",
            minWidth: 160,
            maxWidth: 160,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column6",
            name: "Sub Segment Name",
            fieldName: "subSegementName",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
    ];
    const filterOptions = [
        {
            pillMode: FilterOptionPillMode.Static,
            field: "partnerId",
            label: "Partner ID #",
            values: Array.from(new Set(partnerResults === null || partnerResults === void 0 ? void 0 : partnerResults.map((item) => item.partnerId || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "partnerName",
            label: "Partner Name",
            values: Array.from(new Set(partnerResults === null || partnerResults === void 0 ? void 0 : partnerResults.map((item) => item.partnerName || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "parentIdNumber",
            label: "Parent ID Number #",
            values: Array.from(new Set(partnerResults === null || partnerResults === void 0 ? void 0 : partnerResults.map((item) => item.parentIdNumber || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "parentName",
            label: "Parent Name",
            values: Array.from(new Set(partnerResults === null || partnerResults === void 0 ? void 0 : partnerResults.map((item) => item.parentName || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "subsidiaryName",
            label: "Subsidiary Name",
            values: Array.from(new Set(partnerResults === null || partnerResults === void 0 ? void 0 : partnerResults.map((item) => item.subsidiaryName || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "segmentName",
            label: "Segment Name",
            values: Array.from(new Set(partnerResults === null || partnerResults === void 0 ? void 0 : partnerResults.map((item) => item.segmentName || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "subSegmentName",
            label: "Sub Segment Name",
            values: Array.from(new Set(partnerResults === null || partnerResults === void 0 ? void 0 : partnerResults.map((item) => item.subSegmentName || ""))),
            multiselect: true,
        },
    ];
    const validateSelections = (selections, cusObject) => {
        return ((selections === null || selections === void 0 ? void 0 : selections.length) == 0 ||
            (selections === null || selections === void 0 ? void 0 : selections.every((criteria) => {
                if (criteria.field == "partnerId" && criteria.values !== undefined)
                    return criteria.values.includes(cusObject.partnerId || "undefined");
                else if (criteria.field == "partnerName" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.partnerName || "undefined");
                else if (criteria.field == "parentIdNumber" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.parentIdNumber || "undefined");
                else if (criteria.field == "parentName" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.parentName || "undefined");
                else if (criteria.field == "subsidiaryName" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.subsidiaryName || "undefined");
                else if (criteria.field == "segmentName" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.segmentName || "undefined");
                else if (criteria.field == "subSegmentName" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.subSegmentName || "undefined");
            })));
    };
    useEffect(() => {
        setDisplayPartnerResults(partnerResults);
    }, []);
    useEffect(() => {
        var _a, _b;
        setDisplayPartnerResults((_a = partnerDataSate.PartnerData) !== null && _a !== void 0 ? _a : []);
        setPartnerResults((_b = partnerDataSate.PartnerData) !== null && _b !== void 0 ? _b : []);
    }, [partnerDataSate.PartnerData]);
    useEffect(() => {
        const searchedobj = partnerResults.filter((cusObject) => {
            return (((partnerSearchData === null || partnerSearchData === void 0 ? void 0 : partnerSearchData.trim().length) == 0 ||
                Object.values(cusObject).some((es) => (es === null || es === void 0 ? void 0 : es.toLowerCase().indexOf(partnerSearchData === null || partnerSearchData === void 0 ? void 0 : partnerSearchData.toLowerCase())) !=
                    -1)) &&
                validateSelections(selections, cusObject));
        });
        setDisplayPartnerResults(searchedobj);
    }, [selections, partnerSearchData]);
    const onSearchClick = (tags) => {
        //call action
        setSelectedTags(tags);
        if (tags && tags.length > 0) {
            const partnerRequest = {};
            tags.map((tag) => {
                if (tag.key.toString() == "PartnerName")
                    partnerRequest.PartnerName = tag.text.toString();
                if (tag.key.toString() == "PartnerId")
                    partnerRequest.PartnerId = tag.text.toString();
                if (tag.key.toString() == "CountryName")
                    partnerRequest.Country = tag.text.toString();
                if (tag.key.toString() == "ParentId")
                    partnerRequest.ParentId = tag.text.toString();
                return partnerRequest;
            });
            partnerDataDispatch.GetPartnerDataCollection(partnerRequest);
        }
    };
    const getCountryOptions = useMemo(() => {
        var _a;
        return GetCountryDetailAsDropdownOption((_a = commercialContextState.CommercialContext.CommercialMetadata) === null || _a === void 0 ? void 0 : _a.countries);
    }, [(_b = commercialContextState.CommercialContext.CommercialMetadata) === null || _b === void 0 ? void 0 : _b.countries]);
    return (_jsxs(Stack, Object.assign({ className: "customerResults" }, { children: [_jsx(Stack.Item, Object.assign({ tokens: midStack }, { children: _jsx("div", Object.assign({ className: "closeModelCustomer" }, { children: children })) })), _jsx(Stack.Item, { children: _jsx("div", Object.assign({ style: { paddingLeft: 10 } }, { children: _jsx("h1", Object.assign({ id: "partnerSearchHeading" }, { children: "Search Partners" })) })) }), _jsx(Stack.Item, { children: _jsx("div", Object.assign({ className: "customerSearchPanel" }, { children: _jsx(SearchTags, { initialTags: selectedTags, onSearch: onSearchClick, countriesOptions: getCountryOptions, searchType: SearchType.Partner }) })) }), _jsx(Stack.Item, Object.assign({ styles: { root: { paddingLeft: "10px" } } }, { children: displayPartnerResults.length == 0 &&
                    selectedTags &&
                    selectedTags.length == 0 && (_jsx(Label, { children: "Please search by the fields." })) })), _jsx(Stack.Item, { children: (partnerDataSate === null || partnerDataSate === void 0 ? void 0 : partnerDataSate.InProgress) && _jsx(Spinner, { size: SpinnerSize.large }) }), _jsxs(Stack.Item, Object.assign({ styles: { root: { paddingLeft: "10px" } } }, { children: [(partnerDataSate === null || partnerDataSate === void 0 ? void 0 : partnerDataSate.InProgress) == 0 &&
                        displayPartnerResults.length == 0 &&
                        ((_c = partnerDataSate.PartnerData) === null || _c === void 0 ? void 0 : _c.length) == 0 && (_jsx(Label, { children: "No records found for the search criteria." })), displayPartnerResults.length > 0 && (_jsx(Label, { children: "Only Top 200 records are displayed. Please refine your search to find other records." })), displayPartnerResults.length > 0 && (_jsx(ElxFilter, { options: filterOptions, styles: { root: { width: "100%", maxWidth: 800, minWidth: 0 } }, selections: selections, onChange: setSelections }))] })), _jsx(Stack.Item, Object.assign({ tokens: midStack, styles: {
                    root: {
                        width: "100%",
                        minWidth: 0,
                        maxWidth: "100%",
                        minHeight: "200px",
                        maxHeight: "300px",
                    },
                } }, { children: displayPartnerResults.length > 0 && (_jsx("div", Object.assign({ className: "tableResultsViewport", role: "region", "aria-labelledby": "partnerSearchHeading", tabIndex: 0 }, { children: _jsx(ElxTable, { "data-testid": "customerslist", className: "customersList", selectionMode: SelectionMode.none, items: displayPartnerResults, columns: columns, onActiveItemChanged: (item) => {
                            partnerDataResultDispatch({
                                partnerData: item,
                            });
                            cancelDispatch(false);
                        }, stickyHeader: true, styles: { root: { overflowY: "auto" } } }) }))) }))] })));
};
export default PartnerSearch;
